import * as Sentry from "@sentry/react";
import axios from "axios";
import Cookies from "js-cookie";

import { invalidateSession } from "../ui library/helpers/functions";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://api.healthnsync.com",
  withCredentials: true
});

apiClient.interceptors.request.use((request) => {
  try {
    const storedToken = Cookies.get("pnAccessToken");
    const cookieInStorage = storedToken ? JSON.parse(storedToken) : null;

    if (!request.url.includes("/auth/login") && !cookieInStorage) {
      invalidateSession();
    }

    return request;
  } catch (error) {
    console.error(error);
    invalidateSession();
  }
});

apiClient.interceptors.response.use(
  (response) => {
    const newExpiration = response.headers["x-token-expiry"];
    if (response?.headers && newExpiration) {
      Cookies.set("token_exp", newExpiration);
    }

    return response;
  },
  (error) => {
    const { response, config } = error;

    if (!response) {
      Sentry.captureException(error, {
        tags: { type: "network" },
        extra: {
          message: error.message,
          config: config,
        },
      });
      return Promise.reject(error);
    }

    if (response.status === 401) {
      invalidateSession();
    } else if (response.status === 403) {
      Sentry.captureException(error, {
        tags: { type: "403" },
        extra: {
          url: config?.url,
          method: config?.method,
          response: response?.data,
        },
      });
    }

    return Promise.reject(error);
  }
);

export default apiClient;
